var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper"},[_c('main',{staticClass:"main-content"},[(_vm.showDeactivated)?_c('AccountDeactivated',{attrs:{"slug":_vm.$route.params.slug,"dealer-name":_vm.dealerName}}):_c('router-view')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }